import { useState } from "react";
import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";
import { PaginationProps } from "antd/es/pagination";
import { ISelectOption, ITreeData } from "@/components/YhFormBox/Types";
import { IPgProps } from "@/types/AppTypes";
import { aboutUsService } from "@/views/aboutUs/aboutUsService";
import { introductionsService } from "@/views/introductions/introductionsService";
import { cardService } from "@/views/card/cardService";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}

export function fn(): Promise<ISelectOption[]> {
    let arr: ISelectOption[] = [];
    return Promise.resolve(arr)
}

export type RoleType = {
    id: string,
    name: String,
};
export type UserType = {
    id: string,
    userName: string,
    password: String,
    token: string,
    shopId: string,
    shopName: string,
    shopCode: string,
    loginType?: "account" | "token"
    [key: string]: any
}

export type LoadingType = { loadingVisible: boolean, txt: string };

type GlobalModelType = {
    user: UserType,
    orgDs: any,
    setUser: (e: UserType) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void,
    loadingInfo: LoadingType,
    setLoadingInfo: (origin: LoadingType) => void,

    requestCacheAll: (shopCode?: string) => void,

    resourceAuth: string[],
    setResourceAuth: (origin: string[]) => void

    menuAuth: string[],
    setMenuAuth: (origin: string[]) => void,

    roleAuth: string[],
    setRoleAuth: (origin: string[]) => void,

    fetchCompanyList: (value: string) => Promise<ISelectOption[]>,
    fetchBusinessList: (value: string) => Promise<ISelectOption[]>,
};


const initUserState = {
    id: "",
    userName: "",
    password: "",
    token: "",
    shopId: "",
    shopName: "",
    shopCode: ""
}

type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false
}

function useModel(): GlobalModelType {
    //用户所有菜单权限
    const [menuAuth, setMenuAuth] = useStorageState<string[]>("ebc.user.menus", []);
    //用户角色权限
    const [roleAuth, setRoleAuth] = useStorageState<string[]>("ebc.user.role", []);
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>("ebc.user.resource", []);
    //用户所有信息
    const [user, setUser, resetUser] = useStorageState<UserType>('ebc.user', initUserState);
    const [cm, setCm, resetCm] = useStorageState<CmType>('ebc.cm', initCmState);
    const [orgDs, setOrgDs] = useState<ITreeData[]>([])
    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: "" });

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }

    //实时查询公司介绍接口
    const fetchCompanyList = async (value: string) => {
        // if (!value) return await fn();
        let data = {
            page: {
                pageSize: 15,
                pageNum: 1,
            },
            name: value
        };
        return aboutUsService.page(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                key: item.id ?? "",
                code: item.code ?? "",
                label: item.name ?? "",
                value: item.id ?? "",
                logo: item.logo ?? ""
            })) : [];
        })
    }

    //实时查询业务介绍接口
    const fetchBusinessList = async (value: string) => {
        // if (!value) return await fn();
        let data = {
            page: {
                pageSize: 15,
                pageNum: 1,
            },
            name: value
        };
        return introductionsService.page(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                key: item.id ?? "",
                code: item.code ?? "",
                label: item.name ?? "",
                value: item.id ?? "",
            })) : [];
        })
    }


    //所有缓存加载
    const requestCacheAll = async (shopId = user.shopId) => {
        let orgdsRes = await cardService.orgTreeDs({}) as any;
        console.log(orgdsRes)
        setOrgDs(orgdsRes)
    };

    return {
        user, setUser, resetUser, orgDs,
        cm, toggleMenu, resetCm,
        loadingInfo, setLoadingInfo,
        requestCacheAll,
        resourceAuth, setResourceAuth,
        menuAuth, setMenuAuth,
        roleAuth, setRoleAuth,
        fetchCompanyList,
        fetchBusinessList
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
